import { useTranslation } from 'react-i18next';

const AboutPageAboutUs = () => {
  const { t } = useTranslation();
  return (
    <section className='grid break85:h-full'>
      <div className='grid w-full from-slate-200 to-slate-50  bg-cover bg-no-repeat px-8 pt-16 max-break85:bg-gradient-to-b max-break85:py-8 break85:min-h-[800px] break85:bg-[url("./assets/aboutUsGirl.png")]  break85:pl-[500px] break11:bg-contain'>
        {/* left side */}
        {/* right side */}
        <div className='max-w-xl  text-[0.8rem] font-medium leading-8 text-black sm:text-[1rem]'>
          <p>
            {t('turnAroundAndLook')}
            <span className='font-bold'>{t('buyBuy')}</span>
            {t('seriousMarketing')}
            <span className='font-bold'>{t('moreMore')}</span>
          </p>
          <br className='max-sm:hidden' />
          <p className='font-bold'>{t('thinkLittleDifferently')}</p>
          <br className='max-sm:hidden' />
          <p>{t('frugalPerson')}</p>
          <br className='max-sm:hidden' />
          <p>
            {t('mySecondOne')}
            <span className='text-[1.5rem]'> ☺ ☺ ☺ </span>
            {t('isFeeling')}
          </p>
          <br className='max-sm:hidden' />
          <p className='font-bold'>{t('bothOfTheseFeatures')}</p>
        </div>
      </div>
    </section>
  );
};

export default AboutPageAboutUs;
